import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-work-queue-dashboard",
  templateUrl: "./work-queue-dashboard.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkQueueDashboardComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerMemberManagementDashboardType.Work_Queue_Dashboard;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME2];
}
